export default [
  // {
  //   path: '/STUDENT_Playground',
  //   name: 'STUDENT_Playground',
  //   component: () => import('@/views/pages/STUDENT/Playground.vue'),
  //   meta: { layout: 'content' },
  // },
  // {
  //   path: '/STUDENT_Access_Control',
  //   name: 'STUDENT_Access_Control',
  //   component: () => import('@/views/pages/STUDENT/AccessControl.vue'),
  //   meta: { layout: 'content' },
  // },
  {
    path: '/Notice',
    name: 'Notice',
    component: () => import('@/views/pages/Notice.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/STUDENT_Profile',
    name: 'STUDENT_Profile',
    component: () => import('@/views/pages/STUDENT/Profile.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/STUDENT_Check_In',
  //   name: 'STUDENT_Check_In',
  //   component: () => import('@/views/pages/STUDENT/CheckIn.vue'),
  //   meta: { layout: 'content' },
  // },
  // {
  //   path: '/STUDENT_Check_Out',
  //   name: 'STUDENT_Check_Out',
  //   component: () => import('@/views/pages/STUDENT/CheckOut.vue'),
  //   meta: { layout: 'content' },
  // },
  {
    path: '/STUDENT_Order_History',
    name: 'STUDENT_Order_History',
    component: () => import('@/views/pages/STUDENT/OrderHistory.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/STUDENT_Diary_Record',
    name: 'STUDENT_Diary_Record',
    component: () => import('@/views/pages/STUDENT/DiaryRecord.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/STUDENT_InBody',
    name: 'STUDENT_InBody',
    component: () => import('@/views/pages/STUDENT/InBody.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/STUDENT_Booking_Calendar',
    name: 'STUDENT_Booking_Calendar',
    component: () => import('@/views/pages/STUDENT/BookingCalendar.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/STUDENT_Feedback',
    name: 'STUDENT_Feedback',
    component: () => import('@/views/pages/STUDENT/Feedback.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/STUDENT_Logout',
  //   name: 'STUDENT_Logout',
  //   component: () => import('@/views/pages/STUDENT/Logout.vue'),
  //   meta: { layout: 'content' },
  // },
  {
    path: '/STUDENT_Playground',
    name: 'STUDENT_Playground',
    component: () => import('@/views/pages/STUDENT/Playground.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Playground',
    name: 'COACH_Playground',
    component: () => import('@/views/pages/COACH/Playground.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Access_Control',
    name: 'COACH_Access_Control',
    component: () => import('@/views/pages/COACH/AccessControl.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Profile',
    name: 'COACH_Profile',
    component: () => import('@/views/pages/COACH/Profile.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Student_Profiles',
    name: 'COACH_Student_Profiles',
    component: () => import('@/views/pages/COACH/StudentProfiles.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Create_Order',
    name: 'COACH_Create_Order',
    component: () => import('@/views/pages/COACH/CreateOrder.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Order_History',
    name: 'COACH_Order_History',
    component: () => import('@/views/pages/COACH/OrderHistory.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Diary_Record',
    name: 'COACH_Diary_Record',
    component: () => import('@/views/pages/COACH/DiaryRecord.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_InBody',
    name: 'COACH_InBody',
    component: () => import('@/views/pages/COACH/InBody.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/COACH_InBody_Data_Sync',
  //   name: 'COACH_InBody_Data_Sync',
  //   component: () => import('@/views/pages/COACH/InBodyDataSync.vue'),
  //   meta: { layout: 'content' },
  // },
  {
    path: '/COACH_Booking_Calendar',
    name: 'COACH_Booking_Calendar',
    component: () => import('@/views/pages/COACH/BookingCalendar.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/COACH_Feedback',
  //   name: 'COACH_Feedback',
  //   component: () => import('@/views/pages/COACH/Feedback.vue'),
  //   meta: { layout: 'content' },
  // },
  {
    path: '/COACH_Abnormal_Attendance_Submission',
    name: 'COACH_Abnormal_Attendance_Submission',
    component: () => import('@/views/pages/COACH/AbnormalAttendanceSubmission.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Monthly_Sales_Report',
    name: 'COACH_Monthly_Sales_Report',
    component: () => import('@/views/pages/COACH/MonthlySalesReport.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Commission_Report',
    name: 'COACH_Commission_Report',
    component: () => import('@/views/pages/COACH/CommissionReport.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_Daily_Sales_Register_Report',
    name: 'COACH_Daily_Sales_Register_Report',
    component: () => import('@/views/pages/COACH/DailySalesRegisterReport.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/COACH_StudentProfiles',
    name: 'COACH_StudentProfiles',
    component: () => import('@/views/pages/COACH/StudentProfiles.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Playground',
    name: 'MANAGE_Playground',
    component: () => import('@/views/pages/MANAGE/Playground.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Access_Control',
    name: 'MANAGE_Access_Control',
    component: () => import('@/views/pages/MANAGE/AccessControl.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Coach_Profiles',
    name: 'MANAGE_Coach_Profiles',
    component: () => import('@/views/pages/MANAGE/CoachProfiles.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/MANAGE_Coach_Profiles',
  //   name: 'MANAGE_Coach_Profiles',
  //   component: () => import('@/views/pages/MANAGE/CoachProfilestest.vue'),
  //   meta: { layout: 'content' },
  // },

  {
    path: '/MANAGE_Student_Profiles',
    name: 'MANAGE_Student_Profiles',
    component: () => import('@/views/pages/MANAGE/StudentProfiles.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/MANAGE_Check_In',
  //   name: 'MANAGE_Check_In',
  //   component: () => import('@/views/pages/MANAGE/CheckIn.vue'),
  //   meta: { layout: 'content' },
  // },
  // {
  //   path: '/MANAGE_Check_Out',
  //   name: 'MANAGE_Check_Out',
  //   component: () => import('@/views/pages/MANAGE/CheckOut.vue'),
  //   meta: { layout: 'content' },
  // },
  {
    path: '/MANAGE_Create_Order',
    name: 'MANAGE_Create_Order',
    component: () => import('@/views/pages/MANAGE/CreateOrder.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Order_History',
    name: 'MANAGE_Order_History',
    component: () => import('@/views/pages/MANAGE/OrderHistory.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Diary_Record',
    name: 'MANAGE_Diary_Record',
    component: () => import('@/views/pages/MANAGE/DiaryRecord.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_InBody',
    name: 'MANAGE_InBody',
    component: () => import('@/views/pages/MANAGE/InBody.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/MANAGE_InBody_Data_Sync',
  //   name: 'MANAGE_InBody_Data_Sync',
  //   component: () => import('@/views/pages/MANAGE/InBodyDataSync.vue'),
  //   meta: { layout: 'content' },
  // },
  // {
  //   path: '/MANAGE_Booking_Calendar',
  //   name: 'MANAGE_Booking_Calendar',
  //   component: () => import('@/views/pages/MANAGE/BookingCalendar.vue'),
  //   meta: { layout: 'content' },
  // },

  {
    path: '/MANAGE_Feedback',
    name: 'MANAGE_Feedback',
    component: () => import('@/views/pages/MANAGE/Feedback.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Club_Profile',
    name: 'MANAGE_Club_Profile',
    component: () => import('@/views/pages/MANAGE/ClubProfile.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Locker_Management',
    name: 'MANAGE_Locker_Management',
    component: () => import('@/views/pages/MANAGE/LockerManagement.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Attendance_Management',
    name: 'MANAGE_Attendance_Management',
    component: () => import('@/views/pages/MANAGE/AttendanceManagement.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Abnormal_Attendance_Approval',
    name: 'MANAGE_Abnormal_Attendance_Approval',
    component: () => import('@/views/pages/MANAGE/AbnormalAttendanceApproval.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Monthly_Sales_Report',
    name: 'MANAGE_Monthly_Sales_Report',
    component: () => import('@/views/pages/MANAGE/MonthlySalesReport.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Commission_Report',
    name: 'MANAGE_Commission_Report',
    component: () => import('@/views/pages/MANAGE/CommissionReport.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Daily_Sales_Register_Report',
    name: 'MANAGE_Daily_Sales_Register_Report',
    component: () => import('@/views/pages/MANAGE/DailySalesRegisterReport.vue'),
    meta: { layout: 'content' },
  },

  // {
  //   path: '/MANAGE_Logout',
  //   name: 'MANAGE_Logout',
  //   component: () => import('@/views/pages/MANAGE/Logout.vue'),
  //   meta: { layout: 'content' },
  // },

  {
    path: '/MANAGE_Center',
    name: 'MANAGE_Center',
    component: () => import('@/views/pages/MANAGE/Center.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Promotion',
    name: 'MANAGE_Promotion',
    component: () => import('@/views/pages/MANAGE/Promotion.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_ProgramPrice',
    name: 'MANAGE_ProgramPrice',
    component: () => import('@/views/pages/MANAGE/ProgramPrice.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Program',
    name: 'MANAGE_Program',
    component: () => import('@/views/pages/MANAGE/Program.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Course',
    name: 'MANAGE_Course',
    component: () => import('@/views/pages/MANAGE/Course.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_PrivacyPolicy',
    name: 'MANAGE_PrivacyPolicy',
    component: () => import('@/views/pages/MANAGE/PrivacyPolicy.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Locker',
    name: 'MANAGE_Locker',
    component: () => import('@/views/pages/MANAGE/Locker.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_PaymentMethod',
    name: 'MANAGE_PaymentMethod',
    component: () => import('@/views/pages/MANAGE/PaymentMethod.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_TermsCondition',
    name: 'MANAGE_TermsCondition',
    component: () => import('@/views/pages/MANAGE/TermsCondition.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_LogLockerActivity',
    name: 'MANAGE_LogLockerActivity',
    component: () => import('@/views/pages/MANAGE/LogLockerActivity.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_UserManagement',
    name: 'MANAGE_UserManagement',
    component: () => import('@/views/pages/MANAGE/UserManagement.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_CourseItem',
    name: 'MANAGE_CourseItem',
    component: () => import('@/views/pages/MANAGE/CourseItem.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_OutstandingOrder',
    name: 'MANAGE_OutstandingOrder',
    component: () => import('@/views/pages/MANAGE/OutstandingOrder.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_UserProfile',
    name: 'MANAGE_UserProfile',
    component: () => import('@/views/pages/MANAGE/UserProfile.vue'),
    meta: { layout: 'content' },
  },

  {
    path: '/MANAGE_ReceptionMonitor',
    name: 'MANAGE_ReceptionMonitor',
    component: () => import('@/views/pages/MANAGE/ReceptionMonitor.vue'),
    meta: { layout: 'content' },
  },

  {
    path: '/MANAGE_LockerExcel',
    name: 'MANAGE_LockerExcel',
    component: () => import('@/views/pages/MANAGE/Excel/LockerExcel.vue'),
    meta: { layout: 'blank' },
  },
  {
    path: '/MANAGE_TransferBookingExcel',
    name: 'MANAGE_TransferBookingExcel',
    component: () => import('@/views/pages/MANAGE/Excel/TransferBookingExcel.vue'),
    meta: { layout: 'blank' },

  },
  {
    path: '/MANAGE_SalesReportExcel',
    name: 'MANAGE_SalesReportExcel',
    component: () => import('@/views/pages/MANAGE/Excel/SalesReportExcel.vue'),
    meta: { layout: 'blank' },

  },

  {
    path: '/MANAGE_DailySalesRegisterReportExcel',
    name: 'MANAGE_DailySalesRegisterReportExcel',
    component: () => import('@/views/pages/MANAGE/Excel/DailySalesRegisterReportExcel.vue'),
    meta: { layout: 'blank' },

  },

  // CommissionReportExcel
  {
    path: '/MANAGE_CommissionReportExcel',
    name: 'MANAGE_CommissionReportExcel',
    component: () => import('@/views/pages/MANAGE/Excel/CommissionReportExcel.vue'),
    meta: { layout: 'blank' },

  },

  {
    path: '/MANAGE_ExcelReport',
    name: 'MANAGE_ExcelReport',
    component: () => import('@/views/pages/MANAGE/ExcelReport.vue'),
    meta: { layout: 'content' },

  },

  {
    path: '/MANAGE_IR56B',
    name: 'MANAGE_IR56B',
    component: () => import('@/views/pages/MANAGE/56B.vue'),
    meta: { layout: 'content' },

  },
  {
    path: '/MANAGE_IR56E',
    name: 'MANAGE_IR56E',
    component: () => import('@/views/pages/MANAGE/56E.vue'),
    meta: { layout: 'content' },

  },
  {
    path: '/MANAGE_IR56F',
    name: 'MANAGE_IR56F',
    component: () => import('@/views/pages/MANAGE/56F.vue'),
    meta: { layout: 'content' },

  },
  {
    path: '/OrderPrintView/orderID=:orderID&token=:token',
    name: 'OrderPrintView',
    component: () => import('@/views/pages/OrderPrintView.vue'),
    meta: { layout: 'blank' },
  },
  {
    path: '/MANAGE_Commission_Schema',
    name: 'MANAGE_Commission_Schema',
    component: () => import('@/views/pages/MANAGE/CommissionSchema.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Commission_Schema_Type',
    name: 'MANAGE_Commission_Schema_Type',
    component: () => import('@/views/pages/MANAGE/CommissionSchemaType.vue'),
    meta: { layout: 'content' },
  },
  {
    path: '/MANAGE_Commission_Batch',
    name: 'MANAGE_Commission_Batch',
    component: () => import('@/views/pages/MANAGE/CommissionBatch.vue'),
    meta: { layout: 'content' },
  },
]
